import { COMMON_PERMISSIONS } from '@/commons/permissoesGrupos';

// O acesso de gestão é decidido pelas permissões do token (`meta.permissoes`,
// basta uma delas). O respondente não precisa de permissão: o backend verifica se
// ele é destinatário ou coordena o projeto.
export default [
    // Respondente
    {
        path: '/formularios/meus',
        name: 'meusFormularios',
        component: () => import('@/modules/formularios/views/respondente/MeusFormulariosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
            isRotaOrigem: true,
        },
    },
    {
        path: '/formularios/meus/:aplicacaoId',
        name: 'responderFormulario',
        component: () => import('@/modules/formularios/views/respondente/ResponderFormularioView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
    {
        path: '/formularios/meus/:aplicacaoId/projeto/:projetoId',
        name: 'responderFormularioProjeto',
        component: () => import('@/modules/formularios/views/respondente/ResponderFormularioView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },
    {
        path: '/formularios/obrigatorios',
        name: 'formulariosObrigatorios',
        component: () => import('@/modules/formularios/views/respondente/FormulariosObrigatoriosView.vue'),
        meta: {
            requiresAuth: true,
            allowedRoles: [...COMMON_PERMISSIONS.TODOS],
        },
    },

    // Templates
    {
        path: '/formularios/templates',
        name: 'listaFormularios',
        component: () => import('@/modules/formularios/views/listas/FormulariosView.vue'),
        meta: {
            requiresAuth: true,
            permissoes: ['read:formulario'],
            isRotaOrigem: true,
        },
    },
    {
        path: '/formularios/templates/:id',
        name: 'detalheFormulario',
        component: () => import('@/modules/formularios/views/detalhes/FormularioDetalheView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            permissoes: ['read:formulario'],
        },
    },
    {
        path: '/formularios/templates/:id/editar',
        name: 'construtorFormulario',
        component: () => import('@/modules/formularios/views/cadastros/ConstrutorFormularioView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            permissoes: ['read:formulario'],
        },
    },

    // Aplicações
    {
        path: '/formularios/aplicacoes',
        name: 'listaAplicacoesFormulario',
        component: () => import('@/modules/formularios/views/listas/AplicacoesView.vue'),
        meta: {
            requiresAuth: true,
            permissoes: ['read:formularioaplicacao'],
            isRotaOrigem: true,
        },
    },
    {
        path: '/formularios/aplicacoes/nova',
        name: 'cadastroAplicacaoFormulario',
        component: () => import('@/modules/formularios/views/cadastros/CadastroAplicacaoView.vue'),
        meta: {
            requiresAuth: true,
            permissoes: ['add:formularioaplicacao'],
        },
    },
    {
        path: '/formularios/aplicacoes/:id/editar',
        name: 'editarAplicacaoFormulario',
        component: () => import('@/modules/formularios/views/cadastros/CadastroAplicacaoView.vue'),
        props: true,
        meta: {
            requiresAuth: true,
            permissoes: ['update:formularioaplicacao'],
        },
    },
    {
        path: '/formularios/aplicacoes/:id',
        name: 'detalheAplicacaoFormulario',
        component: () => import('@/modules/formularios/views/detalhes/AplicacaoViews/DetalheAplicacaoView.vue'),
        props: true,
        redirect: { name: 'detalheAplicacaoVisaoGeral' },
        meta: {
            requiresAuth: true,
            permissoes: ['read:formularioaplicacao'],
            temFilhas: true,
        },
        children: [
            {
                path: 'visao-geral',
                name: 'detalheAplicacaoVisaoGeral',
                component: () => import('@/modules/formularios/views/detalhes/AplicacaoViews/abas/VisaoGeralAplicacaoTab.vue'),
                props: true,
                meta: { requiresAuth: true },
            },
            {
                path: 'acompanhamento',
                name: 'detalheAplicacaoAcompanhamento',
                component: () => import('@/modules/formularios/views/detalhes/AplicacaoViews/abas/AcompanhamentoAplicacaoTab.vue'),
                props: true,
                meta: { requiresAuth: true },
            },
            {
                path: 'resultados',
                name: 'detalheAplicacaoResultados',
                component: () => import('@/modules/formularios/views/detalhes/AplicacaoViews/abas/ResultadosAplicacaoTab.vue'),
                props: true,
                meta: { requiresAuth: true, permissoes: ['read:formularioresultado'] },
            },
            {
                path: 'respostas',
                name: 'detalheAplicacaoRespostas',
                component: () => import('@/modules/formularios/views/detalhes/AplicacaoViews/abas/RespostasAplicacaoTab.vue'),
                props: true,
                meta: { requiresAuth: true, permissoes: ['read:formulariosubmissao'] },
            },
            {
                path: 'exports',
                name: 'detalheAplicacaoExports',
                component: () => import('@/modules/formularios/views/detalhes/AplicacaoViews/abas/ExportsAplicacaoTab.vue'),
                props: true,
                meta: { requiresAuth: true, permissoes: ['read:formularioexportacao'] },
            },
        ],
    },
];
